import api from '../api';
import type { User } from '../../types/user';
/**
 * Service function to permanently delete a user account (Admin only).
 * @param userId - The ID of the user to delete.
 * @returns A promise that resolves with a success message.
 */
export const deleteUserAccount = async (userId: string): Promise<string> => {
  try {
    // This calls the DELETE /api/mentor/users/:id route on the backend
    const response = await api.delete<{ message: string }>(`/mentor/users/${userId}`);
    return response.data.message;
  } catch (error: any) {
    if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    throw new Error('Failed to delete user account.');
  }
};




/**
 * Service to update a user's status (Admin only).
 * @param userId - The ID of the user to update.
 * @param status - The new status ('active' or 'suspended').
 */
export const updateUserStatus = async (userId: string, status: 'active' | 'suspended'): Promise<User> => {
  try {
    const response = await api.patch<User>(`/mentor/users/${userId}/status`, { status });
    return response.data;
  } catch (error: any) {
    if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    throw new Error('Failed to update user status.');
  }
};



const adminUserService = {
    deleteUserAccount,
    updateUserStatus,
};

export default adminUserService;